import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
/* eslint-disable @typescript-eslint/no-this-alias */
import moment from "moment";
import { delay } from "../../shared/utils/utils";
import { SELECT2_DEFAULTS } from "./constants";
import globalDeletion from "@Shared/utils/global-deletion.js";
import buttonLoader from "@Shared/utils/button-loader.js";
import { compact, isObject } from "lodash";
export default {
  init($, unitTesting = false) {
    $.fn.getType = function () {
      return this[0].tagName == "INPUT" ? this[0].type.toLowerCase() : this[0].tagName.toLowerCase();
    };
    $.fn.exists = function () {
      return this.length !== 0;
    };
    $.fn.dropdown.Constructor.Default.boundary = "window";
    $.fn.tooltip.Constructor.Default.boundary = "window";
    $.safeString = string => {
      return $("<div>").text(string).html();
    };
    $.fn.dataTableExt && $.extend($.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },
      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      }
    });
    if ($.fn.dataTable) $.extend($.fn.dataTable.defaults, {
      searching: true,
      ordering: true,
      lengthChange: false,
      paging: false,
      language: {
        info: "Showing _END_ of _TOTAL_ records",
        infoFiltered: "(filtered)",
        infoEmpty: "No records",
        zeroRecords: "No matching records found",
        paginate: {
          first: "First",
          last: "Last",
          next: "<i class='fa fa-chevron-right fa-2x' aria-hidden='false'></i>",
          previous: "<i class='fa fa-chevron-left fa-2x' aria-hidden='false'></i>"
        }
      },
      sDom: "<'top'ip>rt<'bottom'fl><'clear'>"
    });
    window.concatData = (forms, data) => {
      let obj = {};
      forms.forEach(element => {
        obj = $.extend(obj, data[element]);
      });
      return obj;
    };
    const isNestedObject = object => {
      const [nextLevel] = _Object$keys(object);
      return typeof object[nextLevel] === "object";
    };
    $.fn.serializeApplication = function (options) {
      const opts = $.extend({}, $.fn.serializeApplication.defaults, options);
      const data = $(this).serializeJSON(opts);
      const cleanRadioButtonName = (data, group, groupIdx = false) => {
        const isMultiGroup = !isNaN(_parseInt(groupIdx));
        const groupData = isMultiGroup ? data[group][groupIdx] : group ? data[group] : data;
        if (!isObject(groupData)) return;
        for (const field in groupData) {
          if (field === "sin") {
            groupData[field] = _objectSpread({}, groupData[field]);
          }
          const endsWithNumber = field.match(/\d+$/);
          if (endsWithNumber) {
            const value = groupData[field];
            delete groupData[field];
            const newField = field.replace(`-${endsWithNumber[0]}`, "");
            groupData[newField] = value;
          }
        }
      };
      const cleanRadioButton = pageData => {
        for (const group in pageData) {
          const groupData = pageData[group];
          if (Array.isArray(groupData)) groupData.forEach((groupTal, idx) => cleanRadioButtonName(pageData, group, idx));else cleanRadioButtonName(pageData, group);
        }
      };
      const cleanStringName = pageData => {
        for (const group in pageData) {
          const groupData = pageData[group];
          if (Array.isArray(groupData)) groupData.forEach((groupTal, idx) => removeComma(pageData, group, idx));else {
            removeComma(pageData, group);
          }
        }
      };
      const removeComma = (data, group, groupIdx = false) => {
        const isMultiGroup = !isNaN(_parseInt(groupIdx));
        const groupData = isMultiGroup ? data[group][groupIdx] : group ? data[group] : data;
        if (!isObject(groupData)) return;
        const groupKeys = _Object$keys(groupData);
        groupKeys.forEach(field => {
          const current = groupData[field];
          if (typeof current != "string") return;
          const numbersWithComma = /^[\d,.]*$/.test(current);
          if (numbersWithComma) groupData[field] = current.replace(/,/g, "");
        });
      };
      for (const key in data) {
        const pageData = data[key];
        if (Array.isArray(pageData)) {
          data[key] = compact(pageData);
          pageData.forEach(page => {
            cleanRadioButton(page);
            cleanStringName(page);
          });
        } else if (isNestedObject(pageData)) {
          cleanRadioButton(pageData);
          cleanStringName(pageData);
        } else {
          cleanRadioButtonName(pageData, false);
          removeComma(pageData, false);
        }
      }
      return data;
    };
    $.fn.serializeApplication.defaults = {
      useIntKeysAsArrayIndex: true
    };
    String.prototype.replaceAll = function (search, replacement) {
      return this.replace(new RegExp(search, "g"), replacement);
    };
    window.getFormattedUTC = timestamp => {
      return moment(timestamp).utc().format("LL");
    };
    $.expr[":"].contains = $.expr.createPseudo(arg => {
      return elem => {
        var _context;
        return _indexOfInstanceProperty(_context = $(elem).text().toUpperCase()).call(_context, arg.toUpperCase()) >= 0;
      };
    });
    (function ($) {
      $.fn.progressbar = function (options) {
        const opts = $.extend({
          interactive: false,
          customClass: "",
          containerSize: 100,
          progress: true,
          stepRender: null
        }, options);
        const {
          interactive,
          customClass,
          progress,
          stepRender
        } = opts;
        const handleClick = (target, container) => {
          if (!$(target).exists() || !$(container).exists()) return;
          if (progress) {
            _findInstanceProperty(container).call(container, ".status").removeClass("current done");
            target.addClass("current");
            const {
              totalSteps
            } = container.data();
            const currentStep = target.index() - 1;
            const stepSize = opts.containerSize / (totalSteps - 1 || 1);
            _findInstanceProperty(container).call(container, ".fill-bar").width(`${stepSize * currentStep}%`);
            markDone(container, currentStep);
          } else {
            target.toggleClass("current");
          }
          target.trigger("pb-step-click");
        };
        const markDone = (container, currentIdx = 0, failIdx = 0) => {
          for (let i = 0; i < currentIdx; i++) {
            $(_findInstanceProperty(container).call(container, ".status")[i]).addClass("done");
          }
          for (let j = 0; j < failIdx; j++) {
            $(_findInstanceProperty(container).call(container, ".status")[j]).addClass("done");
          }
        };
        const getStepElement = step => {
          const userTemplateCallback = typeof stepRender === "function" ? stepRender : null;
          const statusElement = $(`
        <li class="status value-item" filter-value="${step.value}" data-step-id="${step.id}">
          <div class="status-inner-wrapper">
            <div class="status-inner">
              <span>${step.value.replace("@", "").replace("~", "")}</span>  
            </div>
          </div>
        </li>
      `);
          if (userTemplateCallback) {
            const template = userTemplateCallback(step);
            if (typeof template === "string") _findInstanceProperty(statusElement).call(statusElement, ".status-inner").html(template);
          }
          return statusElement;
        };
        return this.each(function () {
          const $this = $(this);
          const {
            steps = []
          } = opts;
          const $ul = $("<ul class='progressbar'>");
          let currentIdx = -1;
          let failIdx = -1;
          let selected = null;
          const count = steps.length;
          $.each(steps, function (index, step) {
            const stepValue = step.value || step;
            const stepData = typeof step === "string" ? {
              id: index,
              value: stepValue
            } : step;
            const $li = getStepElement(stepData);
            if (_includesInstanceProperty(stepValue).call(stepValue, "@")) {
              $li.addClass("current");
              currentIdx = index;
              selected = $li;
            }
            if (_includesInstanceProperty(stepValue).call(stepValue, "~")) {
              $li.addClass("fail");
              failIdx = index;
            }
            $ul.append($li);
          });
          $ul.data("total-steps", count);
          $ul.prepend("<li class='placeholder-bar'>").append("<li class='fill-bar'>");
          if (interactive) {
            $ul.addClass("pb-interactive");
            $ul.on("click", ".status", ({
              currentTarget,
              delegateTarget
            }) => handleClick($(currentTarget), $(delegateTarget)));
          }
          handleClick(selected, $ul);
          if (customClass) {
            $ul.addClass(customClass);
          }
          if (!progress) {
            $ul.addClass("pb-no-progress");
            $ul.children("li.status").removeClass("current");
          }
          markDone($ul, currentIdx, failIdx);
          $this.append($ul);
        });
      };
    })($);
    $.fn.select2.defaults.set("theme", "bootstrap4");
    $.fn.select2.defaults.set("dropdownCssClass", SELECT2_DEFAULTS["dropdownCssClass"]);
    $.fn.select2.defaults.set("containerCssClass", SELECT2_DEFAULTS["containerCssClass"]);

    // Custom selectors
    $.extend($.expr.pseudos, {
      uncheckedSameName: selector => {
        selector = $(selector);
        const name = selector.attr("name");
        return !$(`input[name='${name}']`).is(":checked");
      },
      emptySelect: selector => {
        return !$(selector).val();
      }
    });

    //scrollFixed custom plug in
    (function ($) {
      $.fn.scrollFixed = function (options) {
        $(document).off("scroll", $.fn.scrollFixed.defaults.handleScrollEvent);
        const target = this;
        if (options == "destroy" || !target.exists()) {
          return target;
        }
        target.addClass("scroll-fixed");
        const opts = $.extend({}, $.fn.scrollFixed.defaults, options);
        $.fn.scrollFixed.defaults.handleScrollEvent = () => {
          const shouldFix = target.parent().offset().top - $(window).scrollTop() - opts.offset < 0;
          if (shouldFix) {
            if (!target.hasClass("position-fixed")) target.addClass("position-fixed");
          } else {
            if (target.hasClass("position-fixed")) target.removeClass("position-fixed");
          }
        };
        const bindScrollEvent = () => {
          $("#page").one("scroll", () => {
            $.fn.scrollFixed.defaults.handleScrollEvent();
            const isTargetInDOM = target.get().some(el => $.contains(document, el));
            if (isTargetInDOM) bindScrollEvent();
          });
        };
        bindScrollEvent();
        return this;
      };
      $.fn.scrollFixed.defaults = {
        offset: 0,
        handleScrollEvent: () => {}
      };
    })($);

    //scrolling tabs custom plug in
    (function ($) {
      const calculateScrollControls = ([buttonGoLeft, buttonGoRight], {
        scrollLeft,
        position,
        max
      }) => {
        if (scrollLeft === 0) {
          if (buttonGoLeft.is(":visible")) {
            buttonGoLeft.hide();
          }
        } else if (position >= max) {
          if (buttonGoRight.is(":visible")) {
            buttonGoRight.hide();
          }
        } else {
          if (!buttonGoLeft.is(":visible")) {
            buttonGoLeft.show();
          }
          if (!buttonGoRight.is(":visible")) {
            buttonGoRight.show();
          }
        }
      };
      const doScroll = (scrollingTarget, target) => {
        const delta = target.hasClass("scroll-left") ? -60 : 60;
        scrollingTarget.scrollLeft(scrollingTarget.scrollLeft() + delta);
      };
      const scrollToPrev = (scrollingTarget, whereToScroll) => {
        const firstInViewport = $(whereToScroll).isInViewport({
          viewport: scrollingTarget.parent()
        }).first();
        const prevToFirst = firstInViewport.prev();
        const scrollTarget = prevToFirst.exists() ? prevToFirst : firstInViewport;
        scrollingTarget.scrollTo(scrollTarget, 400);
      };
      const scrollToNext = (scrollingTarget, whereToScroll) => {
        const lastInViewport = $(whereToScroll).isInViewport({
          viewport: scrollingTarget.parent()
        }).last();
        const nextToLast = lastInViewport.next();
        const scrollTarget = nextToLast.exists() ? nextToLast : lastInViewport;
        scrollingTarget.scrollTo(scrollTarget, 400);
      };
      let ticking = false;
      const handleScrollEvent = target => {
        const lastKnownPosition = {};
        lastKnownPosition.scrollLeft = target.scrollLeft();
        lastKnownPosition.position = Math.ceil(lastKnownPosition.scrollLeft + target.innerWidth());
        lastKnownPosition.max = target[0].scrollWidth;
        target.data("scrolling-tab-data", {
          lastKnownPosition
        });
        if (!ticking) {
          const goLeftButton = target.nextAll(".scroll-left");
          const goRightButton = target.nextAll(".scroll-right");
          window.requestAnimationFrame(() => {
            const data = target.data("scrolling-tab-data");
            if (!data) return;
            calculateScrollControls([goLeftButton, goRightButton], data.lastKnownPosition);
            ticking = false;
          });
          ticking = true;
        }
      };
      const handleScrollControlsEvent = (target, whereToScroll) => {
        var _context2;
        const direction = target.hasClass("scroll-left") ? "left" : "right";
        const container = _findInstanceProperty(_context2 = target.parent()).call(_context2, ".scroll-container");
        if (!whereToScroll) return doScroll(container, target);
        if (direction == "left") scrollToPrev(container, whereToScroll);else scrollToNext(container, whereToScroll);
      };
      $.fn.scrollingTab = function (options) {
        const opts = $.extend({}, $.fn.scrollingTab.defaults, options);
        const whereToScroll = opts.whereToScroll;
        const scrollingTarget = $(this);
        scrollingTarget.each((idx, elem) => {
          const currentScrollingTarget = $(elem);
          if (currentScrollingTarget.data("scrolling-tab-data-init")) return true;
          currentScrollingTarget.data("scrolling-tab-data-init", true);
          const goLeftElement = $(`
        <div class="scroll-control scroll-left" style="display:flex;">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </div>
      `);
          const goRightElemnt = $(`
        <div class="scroll-control scroll-right" style="display:flex;">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </div>
      `);
          currentScrollingTarget.addClass("scroll-container");
          currentScrollingTarget.after([goLeftElement, goRightElemnt]);
          $(currentScrollingTarget).scroll(({
            currentTarget
          }) => handleScrollEvent($(currentTarget)));
          currentScrollingTarget.nextAll(".scroll-left, .scroll-right").click(({
            currentTarget
          }) => handleScrollControlsEvent($(currentTarget), whereToScroll));
          handleScrollEvent(currentScrollingTarget);
          currentScrollingTarget.trigger("optimizedResize");
        });
        return this;
      };
      $.fn.scrollingTab.isInit = false;
      $.fn.scrollingTab.defaults = {
        scroller: ".nav-tabs",
        stepSize: 80,
        whereToScroll: null
      };
    })($);
    $.fn.extend({
      trackChanges: function (cb, eventNamespace) {
        const forms = _mapInstanceProperty($).call($, this, form => `#${form.id}`).join();
        $(forms).on(`change.${eventNamespace}`, "select", event => $(event.currentTarget).trigger("input"));
        $(forms).on(`input.${eventNamespace}`, ":input", function (event) {
          $(this.form).attr("changed", true);
          cb($(this.form), event);
        });
      }
    });
    navigator.sayswho = function () {
      var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|edge|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return _sliceInstanceProperty(tem).call(tem, 1).join(" ").replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) _spliceInstanceProperty(M).call(M, 1, 1, tem[1]);
      return M.join(" ");
    }();

    /* jquery custom resize events */
    (function () {
      const THRESHOLD = 200;
      const win = $(window);
      let timeoutId;
      let resizing = false;
      win.on("optimizedResize", function () {
        const timeout = function () {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(function () {
            resizing = false;
            win.trigger("resizeEnd");
          }, THRESHOLD);
        };
        if (!resizing) {
          resizing = true;
          win.trigger("resizeStart");
        }
        timeout();
      });
    })();

    /* taken from https://developer.mozilla.org/en-US/docs/Web/Events/resize#Example - ES6 updated */
    (() => {
      const throttle = (type, name, obj) => {
        obj = obj || window;
        let running = false;
        const func = () => {
          if (running) {
            return;
          }
          running = true;
          requestAnimationFrame(() => {
            obj.dispatchEvent(new CustomEvent(name));
            running = false;
          });
        };
        obj.addEventListener(type, func);
      };

      /* init - you can init any event */
      throttle("resize", "optimizedResize");
    })();

    /*!============================================================
    * jquery.sticky-nav.js
    * Copyright (c) Federico Cargnelutti <fedecarg@gmail.com>
    * http://www.fedecarg.com/
    ============================================================*/

    (function ($) {
      $.fn.stickynav = function (options) {
        const DEFAULT_SELECTORS = {
          navActiveClass: "active",
          // Selected nav item modifier class
          navStickyClass: "sticky",
          // Sticky nav modifier class
          sectionSelector: "section" // Section id, class or tag selector
        };

        // Merge options with defaults
        options = $.extend({}, DEFAULT_SELECTORS, options);

        // Set jQuery DOM elements
        const $nav = this;
        const $navLinks = _findInstanceProperty($nav).call($nav, "a");
        const $sections = $(options.sectionSelector);
        const navHeight = $(".steps").height();
        let offsetNumbers = [0];
        function getOffsetTop(el) {
          const rect = el.getBoundingClientRect(),
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          return Math.round(rect.top + scrollTop);
        }
        function getNavItem(el) {
          return $(`nav a[href="#${$(el).attr("id")}"]`);
        }
        function selectNavItem(el) {
          if (!$nav.hasClass(options.navStickyClass)) {
            $nav.addClass(options.navStickyClass);
          }
          $navLinks.removeClass(options.navActiveClass);
          $(el).addClass(options.navActiveClass);
        }
        function throttle(func, delay) {
          let timer = 0;
          return function () {
            const context = this,
              args = _sliceInstanceProperty([]).call(arguments);
            clearTimeout(timer);
            timer = setTimeout(function () {
              func.apply(context, args);
            }, delay);
          };
        }
        function calculateOffsets() {
          $sections.each(function (index, el) {
            const offsetTop = getOffsetTop(el);
            offsetNumbers.push(offsetTop);
            getNavItem(el).addClass("section-offset-" + offsetTop);
          });
        }
        function onClick(e) {
          e.preventDefault();
          const targetEl = $(this).attr("href");
          if ($(targetEl).length) {
            selectNavItem(this);
          }
        }
        function findClosestNumber(num, arr) {
          return _reduceInstanceProperty(arr).call(arr, function (prev, curr) {
            return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev;
          });
        }
        function isInViewPort(elem) {
          var elementTop = $(elem).offset().top + 350;
          var elementBottom = elementTop + $(elem).outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
        }
        function onScroll() {
          var scrollTop = $(document).scrollTop() + navHeight + 80,
            closestPosition = findClosestNumber(scrollTop, offsetNumbers);
          $(".app-card").each((idx, elem) => {
            if (isInViewPort(elem)) {
              const current = $(elem);
              const currentId = current.attr("id");
              $(".scrollspy-item").removeClass("active");
              $(`.scrollspy-item[href='#${currentId}']`).addClass(`active section-offset-${closestPosition}`);
              $(".app-card").removeClass("on-viewport");
              current.addClass("on-viewport");
            }
          });

          // fix navbar
          if (scrollTop > navHeight + 120) {
            $nav.addClass(options.navStickyClass);
          } else {
            $nav.removeClass(options.navStickyClass);
          }
        }
        function bindEvents() {
          $navLinks.on("click", onClick);
          $(window).on("scroll", throttle(onScroll, 20));
        }
        function initialise() {
          calculateOffsets();
          bindEvents();
        }
        initialise();
      };
    })($);
    /* exported getFormattedDate getFormattedUTC concatData replaceSVG */
    $.fn.getType = function () {
      return this[0].tagName == "INPUT" ? this[0].type.toLowerCase() : this[0].tagName.toLowerCase();
    };
    $.fn.exists = function () {
      return this.length !== 0;
    };
    (() => {
      if (!$.fn.mousewheel || unitTesting) return;
      $(document).on("mousewheel", ".force-horizontal-scroll", function (event, delta) {
        this.scrollLeft -= delta * 40;
      });
      $(document).on("mousewheel", ".ignore-force-horizontal-scroll", function (event) {
        const target = $(event.currentTarget);
        const targetHasScroll = Math.ceil(target.innerHeight()) < target[0].scrollHeight;
        if (targetHasScroll) event.stopImmediatePropagation();
      });
    })();
    (function ($) {
      $.fn.highlight = async function (options = {}) {
        const defaultOptions = {
          bgColor: "var(--primary-3)"
        };
        const opt = $.extend({}, defaultOptions, options);
        const target = this;
        const currentStyle = target.attr("style");
        target.attr("style", `background-color: ${opt.bgColor} !important`);
        target.addClass("highlight-animation");
        await delay(300);
        target.attr("style", "").attr("style", currentStyle);
        await delay(300);
        target.removeClass("highlight-animation");
      };
    })($);
    (function ($) {
      $.getEventKeyCode = function (event) {
        return event.which || event.keyCode;
      };
      $.getEventKey = function (event) {
        return event.key || String.fromCharCode($.getEventKeyCode(event));
      };
    })($);
    (function ($) {
      const heightAnimation = (target, animateHeight, duration) => target.animate({
        height: animateHeight
      }, duration).promise();
      $.fn.slideDownHeight = function (duration = 400, cb = () => {}) {
        const target = this;
        //Get Current Height
        const currentHeight = target.css("height");

        //Set height to auto
        target.css("height", "auto");

        //Store auto height
        var animateHeight = target.css("height");

        //Put height back
        target.css("height", currentHeight);

        //Do animation with animateHeight
        heightAnimation(target, animateHeight, duration).then(() => {
          target.css("height", "auto");
          cb();
        });
      };
      $.fn.slideUpHeight = function (duration = 400, cb = () => {}) {
        const target = this;
        //Do animation with animateHeight
        heightAnimation(target, 0, duration).then(cb);
      };
    })($);
    (function ($) {
      function triggerNativeEvent(el, eventName) {
        if (el.fireEvent) {
          // < IE9
          el.fireEvent("on" + eventName);
        } else {
          var evt = document.createEvent("Events");
          evt.initEvent(eventName, true, false);
          el.dispatchEvent(evt);
        }
      }
      $.fn.triggerNative = function (eventName) {
        return this.each(function () {
          var el = $(this).get(0);
          triggerNativeEvent(el, eventName);
        });
      };
    })($);
    var defaultTooltipWhitelist = $.fn.tooltip.Constructor.Default.whiteList;
    defaultTooltipWhitelist.strike = [];
    (function ($) {
      /**
       * Fix taken from github thread: https://github.com/summernote/summernote/issues/702#issuecomment-404166447
       * On summernote update we need to keep track of this patch in case it breaks.
       */
      if ($.summernote) {
        $.summernote.dom.emptyPara = "<div><br></div>";
        const wrap = (node, wrapperName) => {
          var parent = node.parentNode;
          if (wrapperName === "p") {
            wrapperName = "div";
          }
          var wrapper = $("<" + wrapperName + ">")[0];
          parent.insertBefore(wrapper, node);
          wrapper.appendChild(node);
          return wrapper;
        };
        $.summernote.dom.wrap = wrap;
      }
    })($);
    globalDeletion.init($);
    buttonLoader.init($);
    (function ($) {
      let xhrPool = [];
      $.flushPool = () => {
        $.each(xhrPool, function (idx, jqXHR) {
          jqXHR.abort();
        });
      };
      $(document).ajaxSend(function (e, jqXHR, options) {
        var _options$headers;
        //only add to xhr pool if the call was a GET and protected route
        if ((options == null ? void 0 : options.type) === "GET" && options != null && (_options$headers = options.headers) != null && _options$headers["x-auth-token"]) {
          xhrPool.push(jqXHR);
        }
      });
      $(document).ajaxComplete(function (e, jqXHR, options) {
        var _options$headers2;
        //only remove from xhr pool if the call was a GET and protected route
        if ((options == null ? void 0 : options.type) === "GET" && options != null && (_options$headers2 = options.headers) != null && _options$headers2["x-auth-token"]) {
          xhrPool.push(jqXHR);
          xhrPool = $.grep(xhrPool, function (x) {
            return x != jqXHR;
          });
        }
      });
    })(jQuery);
  }
};